import { render, staticRenderFns } from "./StudentInit.vue?vue&type=template&id=b803b3c0&scoped=true&"
import script from "./StudentInit.vue?vue&type=script&lang=js&"
export * from "./StudentInit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b803b3c0",
  null
  
)

export default component.exports